<script setup lang="ts">
import { onMounted, onUnmounted } from "vue";
import AnalyticsDashboard from "./components/AnalyticsDashboard.vue";
import ResultAdmin from "./components/ResultAdmin.vue";
import HomeScreen from "./components/HomeScreen.vue";
import LeadScreen from "./components/LeadScreen.vue";
import LoadingScreen from "./components/LoadingScreen.vue";
import PlanScreen from "./components/PlanScreen.vue";
import PosterScreen from "./components/PosterScreen.vue";
import QuizScreen from "./components/QuizScreen.vue";
import ResultScreen from "./components/ResultScreen.vue";
import StateScreen from "./components/StateScreen.vue";
import { useSessionStore } from "./stores/session";

const store = useSessionStore();
const isAnalyticsView = new URLSearchParams(window.location.search).get("view") === "analytics";
const isResultAdminView = window.location.pathname.replace(/\/$/, "") === "/admin/results";
const isStandaloneView = isAnalyticsView || isResultAdminView;

function captureError(event: ErrorEvent) {
  store.track("client_error", { message: event.message, source: event.filename, line: event.lineno });
}

onMounted(() => {
  if (isStandaloneView) return;
  store.init();
  window.addEventListener("error", captureError);
});
onUnmounted(() => window.removeEventListener("error", captureError));
</script>

<template>
  <main class="app-shell" :class="{ 'app-shell--analytics': isStandaloneView }">
    <ResultAdmin v-if="isResultAdminView" />
    <AnalyticsDashboard v-else-if="isAnalyticsView" />
    <div v-else class="screen-host">
      <Transition name="screen" mode="out-in">
        <HomeScreen v-if="store.screen === 'home'" key="home" />
        <QuizScreen v-else-if="store.screen === 'quiz'" key="quiz" />
        <LoadingScreen v-else-if="store.screen === 'loading'" key="loading" />
        <ResultScreen v-else-if="store.screen === 'result'" key="result" />
        <PosterScreen v-else-if="store.screen === 'poster'" key="poster" />
        <StateScreen v-else-if="store.screen === 'state'" key="state" />
        <PlanScreen v-else-if="store.screen === 'plan'" key="plan" />
        <LeadScreen v-else key="lead" />
      </Transition>
    </div>

    <footer v-if="!isStandaloneView" class="brand-footer">轻时养，随时养</footer>

    <Transition name="toast">
      <div v-if="store.notice" class="toast" role="status">{{ store.notice }}</div>
    </Transition>
  </main>
</template>
